if (!customElements.get("enova-size-guide")) {
  customElements.define(
    "enova-size-guide",
    class EnovaSizeGuide extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector("[data-sizeguide-drawer]");
        if (!this.drawer) return;

        this.wrapper = this.drawer.querySelector(".m-drawer__wrapper");
        this.content = this.drawer.querySelector(".m-drawer__content");
        this.tabs = Array.from(this.drawer.querySelectorAll("[data-sizeguide-tab]"));
        this.panels = Array.from(this.drawer.querySelectorAll("[data-sizeguide-panel]"));

        // The product section sits below the sticky header in the stacking order,
        // so the drawer only paints above the page once it hangs off the body.
        document.body.appendChild(this.drawer);

        this.querySelector("[data-sizeguide-open]")?.addEventListener("click", (event) => {
          event.preventDefault();
          this.open();
        });

        this.drawer.querySelector("[data-sizeguide-close]")?.addEventListener("click", (event) => {
          event.preventDefault();
          this.close();
        });

        this.wrapper?.addEventListener("click", (event) => {
          if (event.target === this.wrapper) this.close();
        });

        this.onKeydown = (event) => {
          if (event.key === "Escape" && !this.wrapper?.classList.contains("m:hidden")) this.close();
        };
        document.addEventListener("keydown", this.onKeydown);

        this.tabs.forEach((tab) => {
          tab.addEventListener("click", () => this.selectTab(tab.dataset.sizeguideTab));
        });
      }

      disconnectedCallback() {
        document.removeEventListener("keydown", this.onKeydown);
        this.drawer?.remove();
      }

      selectTab(handle) {
        this.tabs.forEach((tab) => {
          tab.setAttribute("aria-selected", tab.dataset.sizeguideTab === handle ? "true" : "false");
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.sizeguidePanel !== handle;
        });
      }

      open() {
        if (window.innerWidth < 770) {
          document.documentElement.classList.add("prevent-scroll");
          this.wrapper.classList.add("mobile");
        }
        this.wrapper.classList.remove("m:hidden");
        requestAnimationFrame(() => {
          this.wrapper.style.setProperty("--m-bg-opacity", "0.5");
          this.content.style.setProperty("--m-translate-x", "0");
          this.content.focus();
        });
      }

      close() {
        this.wrapper.style.setProperty("--m-bg-opacity", "0");
        this.content.style.setProperty("--m-translate-x", "100%");
        setTimeout(() => {
          this.wrapper.classList.add("m:hidden");
          this.wrapper.classList.remove("mobile");
          document.documentElement.classList.remove("prevent-scroll");
        }, 300);
      }
    }
  );
}
